import {
    FETCH_CONSOLIDATED_PUSHES_GOAL,
    FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING,
    FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
    FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL,
    UPDATE_CONSOLIDATED_PUSHES_GOAL,
    UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
    UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL,
    RESET_CONSOLIDATED_PUSHES_GOAL_UPDATE
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    data: null,
    consolidatedPushesGoalFetching: false,
    consolidatedPushesGoalFetchFail: false,
    consolidatedPushesGoalUpdateSucceed: false,
    consolidatedPushesGoalUpdateFail: false
};

//Fetching Handlers
const fetchConsolidatedPushesGoalFetching = (state, action) => {
    return {
        ...state,
        consolidatedPushesGoalFetching: true,
        consolidatedPushesGoalFetchFail: false
    };
};

const fetchConsolidatedPushesGoalSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...action.data
        },
        consolidatedPushesGoalFetching: false,
        consolidatedPushesGoalFetchFail: false
    };
};

const fetchConsolidatedPushesGoalFail = (state, action) => {
    return {
        ...state,
        consolidatedPushesGoalFetching: false,
        consolidatedPushesGoalFetchFail: true
    };
};

//Updating Handlers
const updateConsolidatedPushesGoalSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...action.data
        },
        consolidatedPushesGoalUpdateSucceed: true,
        consolidatedPushesGoalUpdateFail: false
    };
};

const updateConsolidatedPushesGoalFail = (state, action) => {
    return {
        ...state,
        consolidatedPushesGoalUpdateSucceed: false,
        consolidatedPushesGoalUpdateFail: true
    };
};

const resetConsolidatedPushesGoalUpdateFlags = (state) => {
    return {
        ...state,
        consolidatedPushesGoalUpdateSucceed: false,
        consolidatedPushesGoalUpdateFail: false
    };
};

//Handlers
const handlers = {
    [FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING]: fetchConsolidatedPushesGoalFetching,
    [FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS]: fetchConsolidatedPushesGoalSuccess,
    [FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL]: fetchConsolidatedPushesGoalFail,
    [UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS]: updateConsolidatedPushesGoalSuccess,
    [UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL]: updateConsolidatedPushesGoalFail,
    [RESET_CONSOLIDATED_PUSHES_GOAL_UPDATE]: resetConsolidatedPushesGoalUpdateFlags
};

//Default Action
export default function consolidatedPushesGoal(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

//Actions
export function fetchConsolidatedPushesGoal(calendarDate, evictCache) {
    return {
        type: FETCH_CONSOLIDATED_PUSHES_GOAL,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 2000
        }
    };
}

export function updateConsolidatedPushesGoal(calendarDate, newGoal) {
    return {
        type: UPDATE_CONSOLIDATED_PUSHES_GOAL,
        calendarDate: calendarDate,
        newGoal: newGoal
    };
}

export function resetConsolidatedPushesGoalUpdate() {
    return {
        type: RESET_CONSOLIDATED_PUSHES_GOAL_UPDATE
    };
}

//Selectors
export const getConsolidatedPushesGoal = (state) => {
    return state.consolidatedPushesGoal.data ? state.consolidatedPushesGoal.data : null;
};

export const isConsolidatedPushesGoalFetching = (state) => {
    return state.consolidatedPushesGoal.consolidatedPushesGoalFetching;
};

export const didConsolidatedPushesGoalFetchFail = (state) => {
    return state.consolidatedPushesGoal.consolidatedPushesGoalFetchFail;
};

export const didConsolidatedPushesGoalUpdateSucceed = (state) => {
    return state.consolidatedPushesGoal.consolidatedPushesGoalUpdateSucceed;
};

export const didConsolidatedPushesGoalUpdateFail = (state) => {
    return state.consolidatedPushesGoal.consolidatedPushesGoalUpdateFail;
};
